import React, { useState, useEffect, useMemo } from 'react';
import { Button } from '@/components/ui/button';
import { SendHorizonal, Upload } from 'lucide-react';
import * as ww from '@wecom/jssdk';
interface ActionBarProps {
  selectAll: boolean;
  isIndeterminate: boolean;
  onUpdateSelectAll: (value: boolean) => void;
}

const ActionBar: React.FC<ActionBarProps> = ({ selectAll, isIndeterminate, onUpdateSelectAll }) => {
  const [currentSelectAll, setCurrentSelectAll] = useState(false);
  console.log(isIndeterminate, 'isIndeterminate');

  const btnDisabled = useMemo(() => {
    return !selectAll && !isIndeterminate;
  }, [selectAll, isIndeterminate]);

  useEffect(() => {
    setCurrentSelectAll(selectAll);
  }, [selectAll]);

  const handleSelectAllChange = (checked: boolean) => {
    setCurrentSelectAll(checked);
    onUpdateSelectAll(checked);
  };

  const handleSend = async () => {
    console.log('发送1');
    // ww.selectExternalContact({
    //   success: res => {
    //     // const { userId } = res || {};
    //     console.log(res, 'res');
    //   },
    //   fail: err => {
    //     console.log(err, 'err');
    //   }
    // });
    const res = await ww.getCurExternalContact();
    console.log(res, 'res');
    ww.sendChatMessage({
      msgtype: 'text',
      text: {
        content: '你好1111'
      }
    });

    // ww.sendChatMessage({
    //   enterChat: true,
    //   msgtype: 'text',
    //   text: {
    //     content: '你好'
    //   }
    // });
  };

  return (
    <div className="absolute bottom-0 left-0 right-0 rounded-lg px-4">
      <div>
        <div className="flex items-center justify-between bg-white p-3">
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={currentSelectAll}
              onChange={e => handleSelectAllChange(e.target.checked)}
              className="h-4 w-4"
              ref={input => {
                if (input) {
                  input.indeterminate = isIndeterminate;
                }
              }}
            />
            <span className="text-sm text-[#1F1F1F]">全选</span>
          </div>
          <div className="flex gap-2">
            <Button
              className="h-8 rounded bg-gradient-to-r from-[#5D2BC7] to-[#A644CA] px-2 py-1 text-sm text-white shadow-sm"
              disabled={btnDisabled}
              onClick={handleSend}
            >
              <SendHorizonal className="h-4 w-4" />
              <span>发送</span>
            </Button>
            <Button
              className="h-8 rounded border border-[#5959EB] px-2 py-1 text-sm text-[#5959EB]"
              disabled={btnDisabled}
            >
              <Upload className="h-4 w-4" />
              <span>导出</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionBar;
